module.exports = __webpack_public_path__ + "components/MapControl/svg/Punkt widokowy.svg?0d1399e5";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Punkt widokowy.svg
// module id = 2091
// module chunks = 0